export const services = [
    {
        title: "Business Consultancy",
        subtitle: "Tailored Solutions for Smarter Growth",
        description: "Efficiency isn't found by chance; it's crafted through intelligent design. We help tailor business models that ignite smarter growth. Through in-depth consultation, we dig deep into your unique challenges and goals, crafting solutions that streamline operations, supercharge efficiency, and propel your organisation to thrive in evolving markets.",
        icon: "/icons/Home/service-1.svg",
        bgColor: "rgba(4, 33, 63, 0.1)"
    },
    {
        title: "Start-up Funding",
        subtitle: "Investing in Possibility, Driving Progress",
        description: "We transform bold ideas into thriving businesses through venture capital and angel investment in Sri Lanka. Be it start-ups or small businesses, we fuel innovation and support visionary entrepreneurs with capital and expertise, unlocking potential and driving progress, ensuring that every great idea has the chance to shape the future.",
        icon: "/icons/Home/service-2.svg",
        bgColor: "rgba(179, 143, 68, 0.1)"
    },
    {
        title: "Community Empowerment",
        subtitle: "Building Bridges to Brighter Futures",
        description: "Strong communities aren't built overnight—they're nurtured through thoughtful action. Whether it's through education, infrastructure, or child development programs, we focus on long-term impact, nurturing the foundation for stronger, more resilient communities. Step by step, action by action, we cultivate progress that benefits everyone.",
        icon: "/icons/Home/service-3.svg",
        bgColor: "rgba(4, 33, 63, 0.1)"
    },
    {
        title: "ESG/CSR Project Management & Consulting",
        subtitle: "Empowering Resilient and Responsible Businesses",
        description: "We believe that effective ESG/CSR isn't a cost centre, it's a value driver. We collaborate closely with your team to navigate the complex landscape of standards, regulations, and reporting frameworks to develop and implement tailored ESG/CSR solutions that align with your business goals and create genuine value for communities and the environment.",
        icon: "/icons/Home/service-4.svg",
        bgColor: "rgba(179, 143, 68, 0.1)"
    }
];

export const projects = [
    {
        title: "Business & Strategy",
        category: "Business, Finance",
        description: "From market entry to operational excellence, we provide the roadmap for Sri Lankan businesses to go global.",
        image: "/images/Home/Projects-1.svg",
        bgColor: "#ED5F6C",
        path: "/service/business-consultation"
    },
    {
        title: "Financial solution",
        category: "Financial Reporting",
        description: "We move away from traditional debt models to provide venture partnerships that nurture long-term growth.",
        image: "/images/Home/Projects-2.svg",
        bgColor: "#ED5F6C",
        path: "/service/start-up-funding"
    },
    {
        title: "Community Empowerment",
        category: "Community Empowerment",
        description: "Empowering women, educating children, and restoring the heartbeat of rural Sri Lanka.",
        image: "/images/Home/Projects-3.jpg",
        bgColor: "#ED5F6C",
        path: "/service/community-empowerment"
    }
];

export const testimonials = [
    {
        name: "Consultation",
        position: "Emily T., Founder of EcoPack Innovations",
        text: "The team at Symbioun provided invaluable insights that helped us reimagine our business processes. Their tailored approach to consultancy not only improved our productivity but also empowered our staff. We couldn't be happier with the results!",
        image: "/images/Home/testimonial-1.png"
    },
    {
        name: "Investment",
        position: "Sarah L., CEO of InnovateTech Solutions",
        text: "Symbioun was a game changer for our startup. Their venture capital support allowed us to scale quickly and confidently. The team not only provided funding but also valuable mentorship that guided us through crucial phases of growth. I highly recommend their services to any entrepreneur looking to take their business to the next level!",
        image: "/images/Home/testimonial-2.png"
    },
    {
        name: "Consultation",
        position: "CEO, TechInnovate Solutions",
        text: "Working with Symbioun transformed our approach to community development. Their expertise in ESG initiatives helped us create meaningful impact while driving business growth. Their team's dedication and strategic thinking made all the difference.",
        image: "/images/Home/testimonial-1.png"
    },
    {
        name: "Consultation",
        position: "Director, GreenFuture Projects",
        text: "The consulting services provided by Symbioun were exceptional. They helped us navigate complex market challenges and develop sustainable growth strategies. Their insights and guidance have been invaluable to our success.",
        image: "/images/Home/testimonial-2.png"
    }
]; 